import "./menu.scss"

function Menu({ menuOpen, setMenuOpen }) {

    return (
        <div className={"menu " + (menuOpen && "active")}>
            <ul>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#intro">Home</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#portfolio">Photoshop Portfolio</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#works">ReactJS Portfolio</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#certs">Certificates</a>
                </li>
                {/* <li onClick={() => setMenuOpen(false)}>
                    <a href="#socialmedia">Social Media</a>
                </li> */}
            </ul>
        </div>
    );
}

export default Menu;